/**
 ***********************************************
 *
 * ボックスのフローアニメーション
 * 一度のみ実行するタイプ
 * @category 	Application of AZLINK.
 * @author 		Norio Murata <nori@azlink.jp>
 * @copyright 	2010- AZLINK. <http://www.azlink.jp>
 * @final 		2019.04.11
 *
 ***********************************************
 */
(function($) {

	var pluginName = 'flowVox';

	var params = new Array,
		time = '';

	var methods = {
		init: function(options) {
			time = Date.now();
			params[time] = {
				time: time,
				options: '',
				flowAnime: new Array,
				isFlowDefault: false
			}
			params[time].options = $.extend({
				className: 'flowVox', // 名前空間にも使用
				translate: 60,
				duration: 600,
				delay: 300,
				easing: 'easeOutCubic',
				autorun: true, // 自動実行
				autodestroy: true, // 完了後「animeObj」を破棄
				per: $.params.wWidth > $.params.wHeight ? 0.6 : 0.95 // 発火タイミング
			}, options);

			this.each(function(i) {
				$(this).children().each(function() {
					$(this).wrapAll('<div class="animeObj" />');
				});

				var mode = $(this).data('flow') ? $(this).data('flow') : 'up';

				switch (mode) {
					case 'down':
						$(this).find('.animeObj').css({
							visibility: 'visible'
						}).velocity({
							translateY: -params[time].options.translate,
							opacity: 0
						}, 1);
						break;
					case 'left':
						$(this).find('.animeObj').css({
							visibility: 'visible'
						}).velocity({
							translateX: params[time].options.translate,
							opacity: 0
						}, 1);
						break;
					case 'right':
						$(this).find('.animeObj').css({
							visibility: 'visible'
						}).velocity({
							translateX: -params[time].options.translate,
							opacity: 0
						}, 1);
						break;
					case 'leftdown':
						$(this).find('.animeObj').css({
							visibility: 'visible'
						}).velocity({
							translateX: params[time].options.translate,
							translateY: -params[time].options.translate,
							opacity: 0
						}, 1);
						break;
					case 'rightdown':
						$(this).find('.animeObj').css({
							visibility: 'visible'
						}).velocity({
							translateX: -params[time].options.translate,
							translateY: -params[time].options.translate,
							opacity: 0
						}, 1);
						break;
					case 'leftup':
						$(this).find('.animeObj').css({
							visibility: 'visible'
						}).velocity({
							translateX: params[time].options.translate,
							translateY: params[time].options.translate,
							opacity: 0
						}, 1);
						break;
					case 'rightup':
						$(this).find('.animeObj').css({
							visibility: 'visible'
						}).velocity({
							translateX: -params[time].options.translate,
							translateY: params[time].options.translate,
							opacity: 0
						}, 1);
						break;
					case 'zoom':
						$(this).find('.animeObj').css({
							visibility: 'visible'
						}).velocity({
							scale: 0
						}, 1);
						break;
					case 'away':
						$(this).find('.animeObj').css({
							visibility: 'visible'
						}).velocity({
							opacity: 0
						}, 1);
						break;
					case 'mark':
						// $(this).find('.animeObj').parent().unwrap();
						break;
					default:
						$(this).find('.animeObj').css({
							visibility: 'visible'
						}).velocity({
							translateY: params[time].options.translate,
							opacity: 0
						}, 1);
				}

				var param = {
					pos: $(this).find('.animeObj:eq(0)').offset().top,
					isDone: false,
					height: $(this).height(),
					mode: mode
				};

				params[time].flowAnime[i] = function() {
					if ($.params.scrTop > param.pos - ($.params.wHeight * params[time].options.per)) {
						if (param.isDone || !$('.' + params[time].options.className).eq(i).is(':visible')) return;

						$('.' + params[time].options.className).eq(i).find('.animeObj').each(function(j) {
							switch (param.mode) {
								case 'zoom':
									$(this).velocity('stop').velocity({
										scale: 1.2
									}, {
										duration: 300,
										delay: j * params[time].options.delay,
										easing: 'easeInQuint',
										complete: function() {
											$(this).velocity({
												scale: 1.0
											}, {
												duration: 150,
												complete: function() {
													if (params[time].options.autodestroy) $(this).children().unwrap();
												}
											});
										}
									});
									break;
								case 'away':
									$(this).velocity('stop').velocity({
										opacity: 1
									}, {
										duration: params[time].options.duration,
										delay: j * params[time].options.delay,
										easing: params[time].options.easing,
										complete: function() {
											if (params[time].options.autodestroy) $(this).children().unwrap();
										}
									});
									break;
								case 'mark':
									// var target = $(this).parent();
									// if (options.autodestroy) $(this).children().unwrap();
									$(this).parent().addClass('flowActive');
									break;
								default:
									$(this).velocity('stop').velocity({
										translateX: 0,
										translateY: 0,
										opacity: 1
									}, {
										duration: params[time].options.duration,
										delay: j * params[time].options.delay,
										easing: params[time].options.easing,
										complete: function() {
											if (params[time].options.autodestroy) $(this).children().unwrap();
										}
									});
							}
						});

						param.isDone = true;
					}
				};

				if (params[time].options.autorun) methods.run(params[time].flowAnime[i]);
			});

			params[time].isFlowDefault = false;

			return this;
		},
		run: function(fa) {
			// 対象の指定がない場合、flowAnime(配列)に対して行う
			var event = 'scroll.' + params[time].options.className;
			if (fa) {
				$(window).on('scroll.' + params[time].options.className, fa).scroll();
			} else {
				$.each(params[time].flowAnime, function() {
					$(window).on('scroll.' + params[time].options.className, this).scroll();
				});
			}

			return this;
		},
		destroy: function() {
			$(window).off('scroll.' + params[time].options.className);

			return this.each(function(i) {
				$(this).removeClass('flowActive');
				$(this).find('.animeObj').children().unwrap();
			});
		}
	};

	$.fn[pluginName] = function(method) {
		if ( methods[method] ) {
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === 'object' || ! method) {
			return methods.init.apply(this, arguments);
		} else {
			$.error('Method ' + method + ' does not exist on jQuery.' + pluginName);
			return this;
		}
	};

}(jQuery));
